"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LastModifiedBy = exports.TimeColumn = exports.NameSortColumn = void 0;
var react_1 = __importDefault(require("react"));
var react_i18next_1 = require("react-i18next");
var date_1 = require("@/react-app/common/utils/date/date");
function NameSortColumn(_a) {
    var row = _a.row, editHref = _a.editHref;
    return (react_1.default.createElement("td", { className: "table-cell" },
        react_1.default.createElement("a", { className: "automation__table__link", href: editHref(row) },
            react_1.default.createElement("span", { className: "truncated name-display", title: row.name },
                ' ',
                row.name,
                ' '),
            row.description && (react_1.default.createElement("span", { className: "automation__table__description--icon" },
                react_1.default.createElement("span", { className: "eva-tooltip" }, row.description))))));
}
exports.NameSortColumn = NameSortColumn;
function TimeColumn(_a) {
    var _b;
    var row = _a.row, editHref = _a.editHref, column = _a.column;
    var t = (0, react_i18next_1.useTranslation)().t;
    var timeZone = (0, date_1.getUserTimezone)();
    return (react_1.default.createElement("td", { className: "table-cell" },
        react_1.default.createElement("a", { className: "truncated automation__table__link", title: (_b = t('DASHBOARD.STATISTICS.TIMEZONE_TOOLTIP_R18N', { timeZone: timeZone })) !== null && _b !== void 0 ? _b : '', href: editHref(row) }, column && (0, date_1.formatDate)(new Date(row[column] || 0)))));
}
exports.TimeColumn = TimeColumn;
function LastModifiedBy(_a) {
    var row = _a.row, editHref = _a.editHref;
    return (react_1.default.createElement("td", { className: "table-cell" },
        react_1.default.createElement("a", { className: "truncated automation__table__link", href: editHref(row) }, row.lastModifiedBy)));
}
exports.LastModifiedBy = LastModifiedBy;
